import { OFFER_STATUS_COLORS } from '@/constants/offer';
import { GOODS_OFFER_STATUS_COLORS } from '@/views/Brand/Applications/Offer/_components/GoodsOfferStatusCell/goods-offer-status-cell.constants';
export const UNIFIED_OFFER_STATUS_COLORS = {
    ...OFFER_STATUS_COLORS,
    ...GOODS_OFFER_STATUS_COLORS,
};
